/* The site's Character Creation page: its header, the content version and the ?class= / ?blank=
   links around the character module's CharacterLibrary (up to 5 characters on this device). */

import { useNavigate, useSearchParams } from 'react-router-dom';
import { useStrings } from '../locales';
import { useContentVersion } from '../hooks/ContentVersionContext';
import CharacterLibrary from '../character/CharacterLibrary';

export default function CharacterCreation() {
  const strings = useStrings();
  const s = strings.characterCreation;
  const [version] = useContentVersion();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const blank = params.get('blank') ?? undefined;
  return (
    <div className="page-centered cc-page">
      <div className="page-header">
        <h1>{s.title}<span className="beta-chip">{strings.nav.betaBadge}</span></h1>
        <p>{s.desc}</p>
      </div>
      <CharacterLibrary
        version={version}
        startClass={params.get('class') ?? undefined}
        blankClass={blank}
        onBlankBack={() => navigate(`/classes/${blank?.toLowerCase()}`)}
      />
    </div>
  );
}
